// extracted by mini-css-extract-plugin
export default {"countryCodeFlagIcon":"CountryCodeFlagIcon_countryCodeFlagIcon__VrfUB"};